<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP" id="map"> </p>
<p class="IMG"><span aria-label="7" id="pg_7" role="doc-pagebreak"><img alt="image" class="img90" src="images/map.jpg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?53d20c54